import React from "react";
import JsonView, { ReactJsonViewProps } from "react-json-view";
import { Paper, useTheme } from "@mui/material";
import { ErrorBoundary } from "#common/ErrorBoundary";

/**
 * A very thin wrapper to display Json.
 * @param src
 * @param rest
 * @constructor
 */
export const Json: React.FC<
    Omit<ReactJsonViewProps, "src"> & { src: unknown }
> = ({ src, ...rest }) => {
    const useTheme1 = useTheme();
    return (
        <Paper>
            <ErrorBoundary>
                <JsonView
                    theme={
                        useTheme1.palette.mode === "light"
                            ? "bright:inverted"
                            : "bright"
                    }
                    collapsed={2}
                    src={src as any as object}
                    {...rest}
                />
            </ErrorBoundary>
        </Paper>
    );
};
